import React from 'react';
import cx from 'classnames';

import Card from '@marketing/components/card';
import { QuoteCardWithScores } from '@marketing/components/testimonial_card';

import ArrowWithLoop from './assets/arrow_with_loop.png';
import Avatars from './assets/avatars.png';
import TrustpilotLogo from './assets/trustpilot_logo.svg';
import marketingStyles from '@marketing/style.module.scss';

export default (props) => {
  return (
    <div className="d-flex flex-column gap-m">
      <div
        className="align-items-center align-items-lg-start d-flex gap-s"
        style={{ position: 'relative' }}
      >
        <div className="align-items-center d-flex flex-1 flex-lg-none flex-column flex-lg-row gap-s">
          <div>
            <img src={Avatars} alt="Small pictures of happy students" height="24px" width="81px" />
          </div>

          <div className="text-inter" style={{ color: '#5C5C5C' }}>
            Purchased by 500,000+ GRE students
          </div>
        </div>

        <div className="hidden-xs hidden-sm">
          <img
            alt="Arrow pointing down to student testimonials"
            height="50px"
            src={ArrowWithLoop}
            width="80px"
          />
        </div>

        <div
          className="visible-xs visible-sm"
          style={{ position: 'absolute', right: -5, top: 65, transform: 'rotate(85deg)', zIndex: 10 }}
        >
          <img
            alt="Arrow pointing down to student testimonials"
            height="50px"
            src={ArrowWithLoop}
            width="80px"
          />
        </div>
      </div>

      <div className="d-flex hidden-xs hidden-sm" style={{ gap: 18 }}>
        <QuoteCardWithScores
          examSections={[{ name: 'Math', score: 168 }, { name: 'Verbal', score: 169 }]}
          studentName="Nicholas L."
          skewAngle={2}
        >
          "Practice problems, <mark style={{ background: '#FCF0BF' }}>practice tests</mark>, vocab flashcards... all of the resources I needed to succeed. As someone who <mark style={{ background: '#FCF0BF' }}>self-paces</mark>, it was perfect for me to focus on what I needed when I had the time."
        </QuoteCardWithScores>

        <QuoteCardWithScores
          examSections={[{ name: 'Math', score: 170 }, { name: 'Verbal', score: 169 }]}
          studentName="Lottie Jean F."
          skewAngle={-3}
        >
          "The <mark style={{ background: '#FCF0BF' }}>videos explaining the solutions</mark> to different problems were so good! The <mark style={{ background: '#FCF0BF' }}>math lessons</mark> were amazing. They helped me deeply understand the material and grasp the methods to use to approach questions."
        </QuoteCardWithScores>

        <QuoteCardWithScores
          examSections={[{ name: 'Math', score: 165 }, { name: 'Verbal', score: 166 }]}
          studentName="Erica M."
          skewAngle={3}
        >
          "Magoosh had a litany of <mark style={{ background: '#FCF0BF' }}>practice questions</mark> to choose from. My score improved significantly higher on both math and verbal. I greatly appreciate <mark style={{ background: '#FCF0BF' }}>Magoosh's price point</mark> and excellent-quality materials."
        </QuoteCardWithScores>

        <QuoteCardWithScores
          examSections={[{ name: 'Math', score: 170 }, { name: 'Verbal', score: 169 }]}
          studentName="Elyse K."
          skewAngle={-3}
        >
          "Magoosh's personalized, <mark style={{ background: '#FCF0BF' }}>detailed analytics</mark> and challenging practice problems helped me drill into my exact areas of weakness. Using the problems with <mark style={{ background: '#FCF0BF' }}>videos and drills</mark> was incredibly efficient, taking me from a 154 to a 170 Q in just three weeks."
        </QuoteCardWithScores>
      </div>

      <div className="d-flex u-padding-A-l visible-xs visible-sm" style={{ position: 'relative' }}>
        <Card
          skewAngle={2}
          style={{
            // Parent large padding is 31px on each side
            height: 'calc(100% - 62px)',
            left: 31,
            position: 'absolute',
            top: 31,
            width: 'calc(100% - 62px)'
          }}
        />

        <QuoteCardWithScores
          examSections={[{ name: 'Math', score: 168 }, { name: 'Verbal', score: 169 }]}
          studentName="Nicholas L."
          skewAngle={-2}
        >
          "Practice problems, <mark style={{ background: '#FCF0BF' }}>practice tests</mark>, vocab flashcards... all of the resources I needed to succeed. As someone who <mark style={{ background: '#FCF0BF' }}>self-paces</mark>, it was perfect for me to focus on what I needed when I had the time."
        </QuoteCardWithScores>
      </div>

      <div className={marketingStyles.fullContainerWidth} style={{ background: '#FAFAFA', marginTop: 10 }}>
        <div
          className={cx(
            marketingStyles.dashedBorderHorizontal,
            'align-items-center d-flex gap-s justify-content-center u-padding-A-s'
          )}
        >
          <div className="small">
            <strong>4.7</strong> out of 5
          </div>

          <div style={{ color: '#E1E1E1' }}>・</div>

          <div>
            <a href="https://www.trustpilot.com/review/magoosh.com" target="_blank">
              <img alt="Trustpilot logo" src={TrustpilotLogo} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
